/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Select_ProductInputs */

const en_cargo_select_product = /** @type {(inputs: Cargo_Select_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select product`)
};

const es_cargo_select_product = /** @type {(inputs: Cargo_Select_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona producto`)
};

/**
* | output |
* | --- |
* | "Select product" |
*
* @param {Cargo_Select_ProductInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_select_product = /** @type {((inputs?: Cargo_Select_ProductInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Select_ProductInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_select_product(inputs)
	return es_cargo_select_product(inputs)
});